export default __webpack_public_path__ + "static/media/house.fc7a2cac.png";